import { Controller } from '@hotwired/stimulus'
import { debounce } from 'lodash'

export default class extends Controller {

  static targets = [
    'container',
    'customerInfoAlert',
    'firstName',
    'lastName',
    'email',
    'phoneNumber'
  ]

  initialize() {
    this.checkoutContainer = document.querySelector('#checkout-container')
    this.customerUpdate = debounce(this.customerUpdate, 300)
  }

  customerUpdate() {
    let customerUpdateEvent = new CustomEvent('customerUpdate', { detail: {
      first_name: this.firstNameTarget.value, last_name: this.lastNameTarget.value, email: this.emailTarget.value, phone: this.phoneNumberTarget.value
    } });
    this.checkoutContainer.dispatchEvent(customerUpdateEvent);
  }

  validateEmail() {
    const regEx = /\S+@\S+\.\S+/;
    if (regEx.test(this.emailTarget.value)) {
      this.customerInfoAlertTarget.classList.add('hidden');
    } else {
      this.customerInfoAlertTarget.classList.remove('hidden');
    }
  }

  validateInput(event) {
    if (event.target.dataset.target === 'order--customer-info.email') {
      this.validateEmail();
    } else if (event.target.value.trim() === '') {
      this.customerInfoAlertTarget.classList.remove('hidden');
    } else {
      this.validateInputs();
    }
    this.customerUpdate();
  }

  validateInputs() {
    const inputs = ['firstNameTarget', 'lastNameTarget', 'emailTarget', 'phoneNumberTarget'];
    let anyEmpty = inputs.some(input => this[input].value.trim() === '')
    if (anyEmpty) {
      this.customerInfoAlertTarget.classList.add('hidden');
    }
  }

}
